import moment from "moment";
import _ from 'lodash';

export const findActivitiesWithPrimary = (primary, responseArray) => {
  return responseArray.find((a) => a.building == primary);
};

export const getDisplayActicityName = (activity) => {
  
  if (activity.parentName && activity.id === activity.parentId)
   return activity.parentName.toUpperCase();
  if (activity.name && activity.id !== activity.parentId) return activity.name.toUpperCase();
};

export const filterActs = (data) => {
  return data
    .filter((item) => item.isEnabled && item.isParent)
    .sort((a, b) => getDisplayActicityName(a).localeCompare(getDisplayActicityName(b)));
};

export const getDisplayName = (activity, t, i18n) => {
  
  if (activity.parentName && activity.id === activity.parentId)
  return i18n.exists(`other.${activity.idNum}`) ? t(`other.${activity.idNum}`) : activity.parentName
  if (activity.name && activity.id !== activity.parentId)
  return  i18n.exists(`other.${activity.idNum}`) ? t(`other.${activity.idNum}`) : activity.name
};

export const initialRowData = {
  activityName: "",
  workerId: "",
  day1ActivityCount: undefined,
  day1Hours: undefined,
  day2ActivityCount: undefined,
  day2Hours: undefined,
  day3ActivityCount: undefined,
  day3Hours: undefined,
  day4ActivityCount: undefined,
  day4Hours: undefined,
  day5ActivityCount: undefined,
  day5Hours: undefined,
  day6ActivityCount: undefined,
  day6Hours: undefined,
  day7ActivityCount: undefined,
  day7Hours: undefined,
};

const getDate = (week, dayNum=0) =>{
  return moment(week).startOf("week").add(dayNum, "days").format("DD");
}

export const exportHeader = (week, t) => ([
  {key:'activityName', label:""},
  {key:'targetAPH', label:""},
  {key:'average', label:""},
  {key:'worker', label:""},
  {key:'day1ActivityCount', label:`${t("other.dscLblSunday")} (${getDate(week, 0)})`},
  {key:'day1Hours', label:""},
  //{key:'day1Staff', label:""},
  {key:'day2ActivityCount', label:`${t("other.dscLblMonday")} (${getDate(week, 1)})`},
  {key:'day2Hours', label:""},
  //{key:'day2Staff', label:""},
  {key:'day3ActivityCount', label:`${t("other.dscLblTuesday")} (${getDate(week, 2)})`},
  {key:'day3Hours', label:""},
  //{key:'day3Staff', label:""},
  {key:'day4ActivityCount', label:`${t("other.dscLblWednesday")} (${getDate(week, 3)})`},
  {key:'day4Hours', label:""},
  //{key:'day4Staff', label:""},
  {key:'day5ActivityCount', label:`${t("other.dscLblThursday")} (${getDate(week, 4)})`},
  {key:'day5Hours', label:""},
  //{key:'day5Staff', label:""},
  {key:'day6ActivityCount', label:`${t("other.dscLblFriday")} (${getDate(week, 5)})`},
  {key:'day6Hours', label:""},
  //{key:'day6Staff', label:""},
  {key:'day7ActivityCount', label:`${t("other.dscLblSaturday")} (${getDate(week, 6)})`},
  {key:'day7Hours', label:""},
  //{key:'day7Staff', label:""},
  {key:'weekTotalActivityCount', label:`${t("other.dscLblTotal")}`},
  {key:'weekTotalHours', label:""},
  //{key:'weekTotalStaff', label:""},
]);

export const getEmployeeActWeekTotal = (activityData) =>{
  const activityWeekTotal = {
    weekTotalActivityCount : 0,
    weekTotalHours : 0,
    // weekTotalStaff : 0
  }
  if(activityData && Object.keys(activityData).length >0){
    for(let i=0;i<7;i++){
      const activtyCount = activityData[`day${i+1}ActivityCount`] ? activityData[`day${i+1}ActivityCount`] : 0;
      const hours = activityData[`day${i+1}Hours`] ? activityData[`day${i+1}Hours`] : 0;
      const staff = activityData[`day${i+1}Staff`] ? activityData[`day${i+1}Staff`] : 0;
      activityWeekTotal.weekTotalActivityCount += parseFloat(activtyCount);
      activityWeekTotal.weekTotalHours += parseFloat(hours);
      // activityWeekTotal.weekTotalStaff += parseFloat(staff);
    }
  }
  return activityWeekTotal;
}

export const deepArrayEqual = (x, y) => _.isEmpty(_.xorWith(x, y, _.isEqual));

export const getArrayChanges = (x, y) => _.fromPairs(_.differenceWith(_.toPairs(y), _.toPairs(x), _.isEqual));

export const getFormattedEmployeePlan = (employeePlanDoc, productivityHrs=0) => {
  try{
    const formattedPlan = {};
    if(employeePlanDoc){
      const {docId, plan} = employeePlanDoc;
      if(docId && plan){
        const { employeesPlan={}, activities={} } = plan;
        if(employeesPlan && Object.keys(employeesPlan).length >0){
          Object.keys(employeesPlan).forEach(workerId => {
            const workerPlan = employeesPlan[workerId] && employeesPlan[workerId] ['activities'] ? 
                                employeesPlan[workerId] ['activities'] : {};
            const workerDetails = employeesPlan[workerId] && employeesPlan[workerId] ['workerDetails'] ? 
                                  employeesPlan[workerId] ['workerDetails'] : {};
            if(workerPlan && Object.keys(workerPlan).length > 0){
              Object.keys(workerPlan).forEach(actId => {
                const activityPlan = workerPlan[actId];
                if(activityPlan){
                    const rowData = {
                      workerId: workerId,
                      parentId: actId,
                      activityName: activities?.[actId]?.parentName || activities?.[actId]?.name,
                      worker: workerDetails?.label || workerId,
                      workerDetails: workerDetails,
                      targetAPH: activities?.[actId]?.capacity,
                      average: activities?.[actId]?.weekAverage,
                      productivityHrs
                    };
                    Object.keys(activityPlan).forEach(day => {
                      const activityCount = activityPlan?.[day]?.['activityCount'];
                      const hours = activityPlan?.[day]?.['hours'];
                      rowData[`${day}ActivityCount`] = activityCount ? parseFloat(activityCount) : undefined;
                      rowData[`${day}Hours`] = hours ? parseFloat(hours) : undefined;
                    })
                  if(formattedPlan[actId]){
                    rowData.activityId = `${actId}.${(formattedPlan[actId]?.length || 0) + 1}`;
                    formattedPlan[actId] = [...formattedPlan[actId], rowData]
                  }else{
                    formattedPlan[actId] = [];
                    rowData.activityId = `${actId}.${(formattedPlan[actId]?.length || 0) + 1}`;
                    formattedPlan[actId].push(rowData);
                  }
                }
              })
            }
          })
        }
      }
    }

    return formattedPlan;
  }catch(err){
    console.log(" err in getFormattedEmployeePlan", err);
    return {};
  }
}

